
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gQzXD01RbWjTcX7Eo8J8pZjMGIRpOBv_762qH_mW1k2oMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexwEqE0opQU0gNXjw4iLhFiqNTfthQRXfHXBfJ_45G1CXjYMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchsPq9Xw2AAx0NrSFMcQhZdGS_45XRRtIieicOF0JeNMgqcMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexeJ_45tLcSns3UZzMstA_45AMx3pRk4UWveqGBCB_9aGLq_45cMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_936wCV6vmZxx91PHuY_oGsrbap7_aMPZAN4ugrlaBnenYMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexECB7G9lp_yNsvZ8Gb_7vwuCtfLcVvAyGQWVDCky2sm8Meta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93ZkunzbwOQTGQFwiOon_UDK7dLeGcxsNY20oPo58UzlsMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexbjI10GUReUJgbKxkP5IIL97qji4Xdm_45En7vT22PPjWMMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93qvBloHj6q_451oP98bUoHlAgxNCVB50N14mVEwFiD7RIkMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_htwtFmmuQ5oxLLu65NBGrHFNeLUBw0_45zw5rRVoLeIMMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexVpVs_WYMDWfMqFRrYnfesxB8JtDgpV1MXkeSa_InbakMeta } from "/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexECB7G9lp_yNsvZ8Gb_7vwuCtfLcVvAyGQWVDCky2sm8Meta || {},
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexbjI10GUReUJgbKxkP5IIL97qji4Xdm_45En7vT22PPjWMMeta || {},
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_htwtFmmuQ5oxLLu65NBGrHFNeLUBw0_45zw5rRVoLeIMMeta || {},
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexVpVs_WYMDWfMqFRrYnfesxB8JtDgpV1MXkeSa_InbakMeta || {},
    component: () => import("/codebuild/output/src3192515165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]